<div class="mt-20 grid grid-cols-1 justify-items-center">
    <app-loader></app-loader>
    <p>Cargando vehicle manager</p>
    <p class="error" *ngIf="error">{{error}}</p>
</div>